import React from 'react';
import { t } from 'i18next';

import { formatPrice, roundDecimal } from '~utils/number';
import { OFFER_TYPES } from '~constants/buildPizza';

export const hasDiscount = item => item?.discount > 0 && item?.total !== item?.subtotal;

export const getVariantTotal = item => {
  if (item.pointsSpent) {
    return (
      <>
        <i className="icon-star m-right-1" />
        {t('Cart:points', { points: item.pointsSpent })}
      </>
    );
  }

  if (item.menuableId && item.discount) {
    return formatPrice(item.total);
  }

  return formatPrice(
    [OFFER_TYPES.Combo, OFFER_TYPES.Offer].includes(item.offerType) ? item.total : item.subtotal
  );
};

export const canAddWithPoints = (pointsSpent, currentPoints, quantity) =>
  pointsSpent && currentPoints < pointsSpent / quantity;

const filterLoyalty = (item, loyalties) =>
  loyalties?.filter(itemSelected => itemSelected.menuableId === item.menuableId);

export const checkItemPoints = ({ item, cart, totalPoints, loyalties }) => {
  const points = filterLoyalty(item, loyalties)?.[0]?.points || 0;

  return item.pointsSpent !== 0 && totalPoints - cart - points < 0;
};

export const getLoyaltyDescription = (item, loyalties) =>
  filterLoyalty(item, loyalties)?.[0]?.description || filterLoyalty(item, loyalties)?.[0]?.productDescription;

export const getMenuableObject = item => ({ ...item, productId: item.productMenuableId });

// eslint-disable-next-line no-magic-numbers
export const getDiscountPercentage = (subtotal, discount) => roundDecimal((100 * discount) / subtotal, 2);

export const itemIsNotFree = item => item?.total > 0;

export const itemLoyaltyBenefit = (appliedBenefits, item, loyaltyLevels) =>
  appliedBenefits?.find(appliedBenefit =>
    loyaltyLevels?.some(level =>
      level?.loyaltyBenefits.some(
        benefit =>
          benefit?.id === appliedBenefit.id &&
          benefit?.products.some(
            // eslint-disable-next-line max-nested-callbacks
            product => product?.id === item?.productMenuableId || product?.id === item?.menuableId
          )
      )
    )
  );
export const currencySelector = state => state.home.shoppingCart.currency;
